import { Box, Container, Stack, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import SignupForm from "../components/SignupForm";

export default function Newsletter() {
  const baseUrl = import.meta.env.BASE_URL;

  const heroBenefits = [
    "Regelmäßig Tipps und Tricks für mehr Bookings.",
    "Praxisbeispiele von Veranstaltern und Profis.",
    "Checklisten, Vorlagen und konkrete Schritte.",
  ];

  const stats = [
    { strong: "ca. 1x", label: "pro Woche" },
    { strong: "5-10 Minuten", label: "Lesezeit" },
    { strong: "völlig", label: "kostenlos" },
  ];

  const valueCards = [
    {
      title: "Klarer Fokus",
      text: "Kurze, umsetzbare Impulse statt endloser Theorie. Perfekt zwischen Probe und Gig.",
    },
    {
      title: "Mehr Sichtbarkeit",
      text: "Lerne, wie du dich professionell präsentierst und Veranstalter überzeugst.",
    },
    {
      title: "Plan statt Chaos",
      text: "Struktur für deine Selbstständigkeit: Prioritäten, Preise und Positionierung.",
    },
  ];

  return (
    <Box component="main">
      <Box
        component="section"
        aria-label="Newsletter - Hero"
        className="sectionBg sectionA"
        sx={(theme) => ({
          position: "relative",
          overflow: "hidden",
          py: { xs: 7, md: 10 },
          pt: { xs: 9, md: 12 },
          background:
            theme.palette.mode === "dark"
              ? "radial-gradient(1100px 520px at 12% 0%, rgba(163,216,30,0.22), transparent 56%), radial-gradient(900px 500px at 90% 18%, rgba(23,23,15,0.18), transparent 56%)"
              : "radial-gradient(1100px 520px at 12% 0%, rgba(163,216,30,0.14), transparent 56%), radial-gradient(900px 500px at 90% 18%, rgba(23,23,15,0.10), transparent 56%)",
        })}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
              gap: { xs: 4, md: 8 },
              alignItems: "center",
            }}
          >
            <Stack spacing={3.5} sx={{ order: { xs: 1, md: 0 } }}>
              <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 2 }}>
                Newsletter
              </Typography>
              <Typography
                sx={{
                  fontWeight: 900,
                  letterSpacing: "-0.05em",
                  lineHeight: 1.02,
                  fontSize: { xs: "2.4rem", sm: "3rem", md: "3.6rem" },
                }}
              >
                Tipps und Tricks zum Musiker-Erfolg
              </Typography>
              <Typography sx={{ color: "text.secondary", fontSize: { xs: "1.08rem", md: "1.15rem" } }}>
                Erhalte regelmäßig klare Impulse, die dich im Musikbusiness voranbringen. Kurz, konkret und sofort
                umsetzbar.
              </Typography>

              <Stack spacing={1.4}>
                {heroBenefits.map((item) => (
                  <Stack key={item} direction="row" spacing={1.2} alignItems="flex-start">
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        bgcolor: "rgba(16,185,129,0.12)",
                        display: "grid",
                        placeItems: "center",
                        mt: "2px",
                      }}
                    >
                      <CheckCircleRoundedIcon sx={{ fontSize: 20, color: "success.main" }} />
                    </Box>
                    <Typography
                      color="text.secondary"
                      sx={{ fontWeight: 700, fontSize: { xs: "1.02rem", md: "1.08rem" }, lineHeight: 1.4 }}
                    >
                      {item}
                    </Typography>
                  </Stack>
                ))}
              </Stack>

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1.2,
                  maxWidth: 460,
                }}
              >
                {stats.map((x) => (
                  <Stack
                    key={x.strong}
                    direction="row"
                    spacing={0.6}
                    alignItems="center"
                    sx={{
                      px: 1.6,
                      py: 0.8,
                      bgcolor: "action.hover",
                      borderRadius: 999,
                      minHeight: 36,
                      justifyContent: "center",
                      flex: "0 1 auto",
                    }}
                  >
                    <Typography variant="caption" sx={{ fontWeight: 900 }}>
                      {x.strong}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {x.label}
                    </Typography>
                  </Stack>
                ))}
              </Box>

              <Stack spacing={1.2} sx={{ width: "100%", maxWidth: 420 }}>
                <SignupForm />
                <Typography variant="caption" sx={{ color: "text.secondary" }}>
                  Kostenlos anmelden. Jederzeit abmelden.
                </Typography>
              </Stack>
            </Stack>

            <Stack
              spacing={2}
              alignItems="center"
              sx={{ height: "100%", justifyContent: "center", order: { xs: -1, md: 0 } }}
            >
              <Box
                component="img"
                src={baseUrl + "newsletter_mockup.png"}
                alt="Newsletter Vorschau"
                loading="eager"
                sx={{
                  width: { xs: "86%", sm: "72%", md: "90%" },
                  maxWidth: { xs: 300, sm: 360, md: 520 },
                  height: "auto",
                  display: "block",
                  objectFit: "cover",
                  filter: "drop-shadow(0 28px 60px rgba(15,23,42,0.25))",
                  mx: "auto",
                }}
              />
            </Stack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
